import { PostIdentitiesRequestProviderEnum } from 'auth0';

/**
 * Mapping of Auth0 account providers to display names.
 */
const ACCOUNT_PROVIDER_NAMES = {
  [PostIdentitiesRequestProviderEnum.auth0]: 'Email & Password',
  [PostIdentitiesRequestProviderEnum.google_oauth2]: 'Google',
  [PostIdentitiesRequestProviderEnum.facebook]: 'Facebook',
  [PostIdentitiesRequestProviderEnum.github]: 'GitHub',
  [PostIdentitiesRequestProviderEnum.linkedin]: 'LinkedIn',
};

/**
 * Check if an account type is a social account.
 * By just checking if it's not 'auth0'.
 */
export const isSocialAccountType = (accountType: string) => {
  return accountType !== PostIdentitiesRequestProviderEnum.auth0;
};

/**
 * Grab the account provider (auth0, google-oauth2, etc) from an Auth0 user ID
 * @param authId The Auth0 user ID (e.g., "auth0|1234567890") or "google-oauth2|1234567890"
 * @returns The account provider portion of the ID (e.g. "auth0" or "google-oauth2")
 */
export const getAccountProvider = (authId: string) => {
  const accountProvider = authId.split('|')[0] as PostIdentitiesRequestProviderEnum;
  return accountProvider;
};

/**
 * Grab the nicely-formatted name for the account provider from an Auth0 user ID
 * @param authId The Auth0 user ID (e.g., "auth0|1234567890") or "google-oauth2|1234567890"
 * @returns The display name for the account provider (e.g. "Email & Password" or "Google")
 */
export const getAccountProviderDisplayName = (authId: string) => {
  const provider = getAccountProvider(authId);
  return ACCOUNT_PROVIDER_NAMES[provider] || provider;
};

export function extractEmails(value: string | null | undefined): string[] {
  return value?.toLowerCase().match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi) ?? [];
}

export function extractFirstEmail(value: string | null | undefined): string | null {
  const emails = extractEmails(value);
  return emails.length > 0 ? emails[0] : null;
}
